import { render, staticRenderFns } from "./LoyaltyLogo.vue?vue&type=template&id=105a8ad8&scoped=true"
import script from "./LoyaltyLogo.vue?vue&type=script&lang=js"
export * from "./LoyaltyLogo.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyLogo.vue?vue&type=style&index=0&id=105a8ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105a8ad8",
  null
  
)

export default component.exports